import tokenData from '../../design-tokens/base-tokens.json';
export const MuiList = {
    styleOverrides: {
        root: ({ theme }) => ({
            minWidth: '200px',
            'dt, dt.OclcDefinitionTerm': {
                fontWeight: 700
            },
            '& div': {
                '&:focus': {
                    outline: 'none',
                    '& .MuiMenuItem-root': {
                        background: tokenData.tokens.palette.grey.grey100
                    }
                }
            },
            '& .MuiCollapse-root': {
                paddingLeft: '12px',
                paddingRight: '12px',
                '& > div > div > ul': {
                    padding: 0
                }
            },
            '& > div.MuiListItemButton-root': {
                padding: theme.spacing(2, 4),
                '&.MuiListItemButton-dense': {
                    padding: theme.spacing(0.5, 4)
                }
            },
            '&.MuiMultiSectionDigitalClockSection-root': {
                minWidth: 0
            }
        }),
        dense: ({ theme }) => ({
            '& .MuiMenuItem-root': {
                padding: theme.spacing(0.5, 4),
                ...theme.typography.body1,
                minHeight: 'auto'
            }
        })
    }
};
export const MuiListItem = {
    styleOverrides: {
        root: ({ theme }) => ({
            padding: 0,
            '& .MuiListItemButton-root': {
                padding: theme.spacing(2, 4)
            },
            '& .MuiListItemIcon-root': {
                color: tokenData.tokens.palette.text.text100,
                minWidth: 32
            }
        }),
        dense: ({ theme }) => ({
            '& .MuiListItemButton-root': {
                padding: theme.spacing(0.5, 4)
            },
            '& .MuiSwitch-root': {
                marginBottom: 4
            },
            '& .MuiListItemIcon-root': {
                minWidth: 28
            },
            '& .MuiListItemText-inset': {
                paddingLeft: 28
            }
        })
    }
};
export const MuiListItemButton = {
    styleOverrides: {
        root: {
            padding: 0,
            '&:hover': {
                backgroundColor: tokenData.tokens.palette.grey.grey100
            },
            '&.Mui-focusVisible': {
                backgroundColor: tokenData.tokens.palette.grey.grey100,
                outline: '2px solid #000000 !important',
                outlineOffset: -2
            },
            '&.Mui-selected': {
                backgroundColor: tokenData.tokens.palette.blue.blue100
            },
            '& .MuiListItemIcon-root': {
                color: tokenData.tokens.palette.text.text100,
                minWidth: 28
            },
            '& .MuiListItemText-inset': {
                paddingLeft: 28
            }
        }
    }
};
export const MuiListItemText = {
    styleOverrides: {
        root: {
            margin: 0
        },
        primary: {
            color: tokenData.tokens.palette.text.text300
        },
        secondary: {
            color: tokenData.tokens.palette.text.text200,
            fontSize: '0.75rem'
        },
        inset: {
            paddingLeft: 32
        }
    }
};
export const MuiListSubheader = {
    styleOverrides: {
        root: {
            color: tokenData.tokens.palette.blue.blue700,
            padding: '0px 8px',
            lineHeight: '24px',
            fontWeight: 500,
            fontSize: '0.875rem'
        }
    }
};
